
import { Vue, Prop } from 'vue-property-decorator'
import { Inspiration } from '@/types/discover'
import {
  thumbnailImage,
  formattedCountriesText,
  logEvent,
} from '@/utils/utility-manager'
import { authModule } from '@/store'

class InspirationCard extends Vue {
  @Prop() readonly inspiration!: Inspiration

  get countryByLocale(): string {
    return formattedCountriesText(
      this.inspiration,
      this.$i18n.locale,
      `${this.$t('other') as string}`,
      `${this.$t('others') as string}`,
    )
  }

  getThumbnail(image: string, size: number): string {
    return thumbnailImage(image, size)
  }

  async handleClick(params: {
    inspiration: Inspiration
    source?:
      | 'header_card'
      | 'list_card'
      | 'bookmark_card'
      | 'slide_card'
      | 'grid_card'
  }) {
    logEvent('inspiration_opened', {
      context: authModule.loggedIn ? 'signed_in' : 'onboarding_v3',
      inspiration_id: params.inspiration._id,
      source: params.source,
    })

    await this.$router.push({
      name: 'discover-inspiration-inspiration',
      params: {
        inspiration: params.inspiration._id,
        name: params.inspiration.name,
      },
    })
  }
}

export default InspirationCard
